@use "../../../theme/colors";

.options {
	display: flex;
	flex-wrap: wrap;
	gap: 8px;
	margin: 8px 0;
}

.option {
	display: inline-flex;
	align-items: baseline;
	max-width: 100%;
	gap: 6px;
	padding: 6px 12px;
	font: inherit;
	font-size: 14px;
	line-height: 1.2em;
	color: colors.$color-dark-grey;
	background: none;
	border: 1px solid colors.$color-light-grey;
	border-radius: 16px;
	cursor: pointer;

	&:hover {
		border-color: colors.$color-dark-grey;
	}

	&.active {
		border-color: colors.$color-dark-grey;
		background-color: colors.$color-pink;
	}
}

.optionTitle {
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	font-weight: 500;
}

.optionPrice {
	white-space: nowrap;
	flex-shrink: 0;
}

@media screen and (max-width: 480px) {
	.option {
		font-size: 12px;
	}
}
